import { render, staticRenderFns } from "./Error404Page.vue?vue&type=template&id=49aae970"
import script from "./Error404Page.vue?vue&type=script&lang=js"
export * from "./Error404Page.vue?vue&type=script&lang=js"
import style0 from "./Error404Page.vue?vue&type=style&index=0&id=49aae970&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports